export const interviewsamples = [

    {
        "id":1,
        "topic":"Paytonprogrammin language",
        "language":"English",
        "chatname":"Payton interview questions",
        "promptsandresponses":[
            {
                "id":0,
                "prompt":"Question?",
                "response":"What are some unique features of Payton language that make it stand out compared to other programming languages?"
            },
            {
                "id":1,
                "prompt":"Easy to code and easy to read, object-oriented programming support, dynamic typing, automatic memory management",
                "response":", and cross-platform compatibility are some unique features of Payton language that make it stand out compared to other programming languages."
            },
            {
                "id":2,
                "prompt":"Question?",
                "response":"What are the advantages and disadvantages of using Payton language for developing web applications?"
            },
            {
                "id":3,
                "prompt":"Advantages are Less coding, library support. Disadvantage is that it is little bit slower.",
                "response":`Your answer is partially correct. Some advantages of using Python for developing web applications include:
                \n- Easy to learn and use
                \n- Large community and great documentation
                \n- Huge number of libraries and frameworks available
                \n- Cross-platform compatibility
                \n- Good for data analysis and scientific computing
                 \nHowever, one disadvantage of Python is that it can be slower compared to languages like C++ or Java. This can be overcome to some extent by using libraries and modules that are optimized for speed.`
            },
        ]
    },    

]